import type { AssistantConversation } from './types';

// What the assistant is doing right now, from data the panel already polls
// (no backend field): sending, thinking, a named step, editing the page in
// this tab, capturing frames, or waiting for a confirmation click.

export type AssistantActivity =
  | { kind: 'idle' }
  | { kind: 'sending' }
  | { kind: 'thinking' }
  | { kind: 'tool'; toolName: string; toolTitle: string | null }
  | { kind: 'editing' }
  | { kind: 'capturing' }
  | { kind: 'awaiting_confirmation' };

export const CAPTURE_TOOL_NAME = 'editor_capture_frames';

export function deriveAssistantActivity({ sending, conversation, ownsTurn }: {
  sending: boolean;
  conversation: Pick<AssistantConversation, 'status' | 'messages' | 'pending_client_calls'> | null;
  ownsTurn: boolean;
}): AssistantActivity {
  if (sending) return { kind: 'sending' };
  if (!conversation) return { kind: 'idle' };
  if (conversation.status === 'awaiting_confirmation') return { kind: 'awaiting_confirmation' };
  if (conversation.status === 'awaiting_client') {
    if (!ownsTurn) return { kind: 'idle' };
    return conversation.pending_client_calls.some((call) => call.tool_name === CAPTURE_TOOL_NAME)
      ? { kind: 'capturing' }
      : { kind: 'editing' };
  }
  if (conversation.status !== 'running') return { kind: 'idle' };
  const last = conversation.messages[conversation.messages.length - 1];
  if (last?.role === 'tool' && last.tool_status === null && !last.action && last.tool_name) {
    return { kind: 'tool', toolName: last.tool_name, toolTitle: last.tool_title };
  }
  return { kind: 'thinking' };
}
